import { makeStyles } from '@material-ui/core';
import React from 'react';
import { getColor } from 'common/constants/_colors';
import { Flex } from './base/layout-components';
import StyledAvatar from 'components/StyledAvatar';

const useStyles = makeStyles({
  colorDefault: {
    color: '#fff',
    backgroundColor: getColor('chambray')
  }
});

const MultipleAvatars = ({
  avatars = [],
  onClick,
  limit = 4,
  disableTooltip,
  disableTooltipForRest = false,
  changeCursor,
  getCustomEndingAvatar = null,
  size
}) => {
  const classes = useStyles();
  const shouldSliceAvatars = limit && avatars.length > limit;
  const limitedAvatars = shouldSliceAvatars
    ? avatars.slice(0, limit - 1)
    : avatars;
  const Avatars = limitedAvatars.map((avatar, idx) => (
    <StyledAvatar
      avatar={avatar}
      key={idx}
      idx={idx}
      onClick={onClick}
      disableTooltip={disableTooltip}
      content={avatar && avatar.withContent && avatar.name ? avatar.name : null}
      changeCursor={changeCursor}
      size={size}
    />
  ));

  if (shouldSliceAvatars) {
    const avatar = {
      name: avatars
        .slice(limit, avatars.length)
        .map(({ name }) => name)
        .join(', '),
      url: ''
    };
    Avatars.push(
      <StyledAvatar
        key={limit}
        avatar={avatar}
        idx={limit + 1}
        onClick={null}
        disableTooltip={disableTooltipForRest || disableTooltip}
        classes={classes}
        content={`+${avatars.length - (limit - 1)}`}
        size={size}
      />
    );
  }

  if (getCustomEndingAvatar) {
    Avatars.push(
      getCustomEndingAvatar({
        idx:
          limitedAvatars.length === 0
            ? 0
            : limitedAvatars.length + (shouldSliceAvatars ? 2 : 1)
      })
    );
  }
  return (
    <Flex direction='row' items='center'>
      {Avatars}
    </Flex>
  );
};

export default MultipleAvatars;
